/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-12-08 15:33:56
 **/

import { ChronoUtils, Configure, Environments, Properties, Utility } from "@/frameworks/libraries";
import { usePersistStore } from "@/frameworks/core/persistence";

function get_me_for_token_check() {
	return new Promise((resolve, reject) => {
		const domain = Environments.env<string | null>("API_DOMAIN");
		fetch(Utility.URLNormalize(domain) + "/api/users/me", {
			method: "get",
			//*
			credentials: "include",
			/*/
			headers: {
				"Content-Type": "application/json",
				Authorization: Configure.authorizationKey as string
			}
			//*/ headers: {
				deviceKey: Properties.browserTabID
			}
		})
			.then((response) => {
				switch (response.status) {
					case 200: {
						return response.json();
					}

					default: {
						return reject(new Response(response.statusText, { status: response.status }));
					}
				}
			})
			.then((result) => {
				Configure.userID = result.userId;
				if (result.authority === "GUEST") {
					Properties.property = { isGuest: true };
				}
				resolve(result);
			})
			.catch((error: unknown) => {
				Configure.userID = null;
				reject(error);
			});
	});
}

function reissue_token() {
	return new Promise((resolve, reject) => {
		const domain = Environments.env<string | null>("API_DOMAIN");
		fetch(Utility.URLNormalize(domain) + "/api/reissue_token", {
			method: "POST",
			credentials: "include",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				refreshToken: Configure.refreshToken
			})
		})
			.then((response) => {
				switch (response.status) {
					case 200: {
						return response.json();
					}

					default: {
						return reject(new Response(response.statusText, { status: response.status }));
					}
				}
			})
			.then(({ accessToken, refreshToken }) => {
				if (!accessToken && !refreshToken) {
					return;
				}
				Configure.authorizationKey = accessToken;
				Configure.refreshToken = refreshToken;
				resolve(true);
			})
			.catch(reject);
	});
}

export default function check_or_refresh() {
	return new Promise((resolve, reject) => {
		get_me_for_token_check()
			.then((result) => {
				const { states } = usePersistStore.getState();
				ChronoUtils.set_timezone(states.timezone);
				resolve(result);
			})
			.catch((error) => {
				if (error.status === 401) {
					// refresh toren
					reissue_token()
						.then(() => {
							get_me_for_token_check()
								.then((result) => resolve(result))
								.catch((error) => {
									reject(error);
								});
						})
						.catch((error: unknown) => {
							if (location.hostname === "localhost") {
								if (error === "Failed to fetch") {
									return reject(new Response("faile to fetch", { status: 401 }));
								}
							}
							reject(error);
						});
				} else {
					reject(error);
				}
			});
	});
}
